import React from 'react'
import { css } from '@emotion/css'
import { tooltipTitleCss } from '../../design-system'
import { FormattedMessage } from 'react-intl'
import { getVulnerabilityDiscussionRoute } from '../route'
import { BugTracker } from '.'
import { Link } from '@contrast-security-inc/design-system-typography'
import { theme } from '@contrast-security-inc/design-system-foundations'

export function BugTrackerTooltipContent({
  bugTrackers,
  organizationID,
  vulnerabilityID
}: {
  readonly bugTrackers: BugTracker[]
  readonly organizationID: string
  readonly vulnerabilityID: string
}) {
  return (
    <React.Fragment>
      <FormattedMessage
        id="title_sentToBugtracker"
        children={(text) => <div className={tooltipTitleCss} children={text} />}
      />
      <BugTrackersList
        bugTrackers={bugTrackers}
        organizationID={organizationID}
        vulnerabilityID={vulnerabilityID}
      />
    </React.Fragment>
  )
}

export function BugTrackersList({
  bugTrackers,
  organizationID,
  vulnerabilityID
}: {
  readonly bugTrackers: BugTracker[]
  readonly organizationID: string
  readonly vulnerabilityID: string
}) {
  return (
    <React.Fragment>
      {bugTrackers.length > 0 ? (
        <ul
          className={css`
            list-style-type: none;
            padding: 0;
            margin: 0;
          `}
        >
          {bugTrackers.map(({ name, type, ticketUrl, ticketKey }, index) => (
            <li key={index}>
              <span>
                {name} ({type})
              </span>
              <TicketUrl
                ticketUrl={ticketUrl}
                ticketKey={ticketKey}
                type={type}
              />
            </li>
          ))}
        </ul>
      ) : (
        <span>
          <FormattedMessage id="detail_vulnerabilitiesBugTracker_bugTrackerNotConfigured" />
          <div>
            <FormattedMessage
              id="detail_vulnerabilitiesBugTracker_seeLinkForTicketDetails"
              values={{
                link: (
                  <DiscussionUrl
                    organizationID={organizationID}
                    vulnerabilityID={vulnerabilityID}
                  />
                )
              }}
            />
          </div>
        </span>
      )}
    </React.Fragment>
  )
}

export function TicketUrl({
  ticketUrl,
  ticketKey,
  type
}: {
  readonly ticketUrl?: string
  readonly ticketKey: string
  readonly type: string
}) {
  return ticketUrl ? (
    <Link
      href={ticketUrl}
      isExternal
      className={css`
        color: ${theme.color.turquoise50} !important;
        margin-left: 5px;
      `}
      children={
        <React.Fragment>
          <span>
            {type === 'VSTS' && (
              <FormattedMessage
                id="title_workItem"
                children={(text) => (
                  <React.Fragment>
                    <span>{text}</span>
                    <span> - </span>
                  </React.Fragment>
                )}
              />
            )}
          </span>
          <span>{ticketKey}</span>
        </React.Fragment>
      }
    />
  ) : (
    <span>{ticketKey}</span>
  )
}

function DiscussionUrl({
  organizationID,
  vulnerabilityID
}: {
  readonly organizationID: string
  readonly vulnerabilityID: string
}) {
  return (
    <FormattedMessage
      id="title_discussion"
      children={(msg) => (
        <Link
          href={getVulnerabilityDiscussionRoute(
            organizationID,
            vulnerabilityID
          )}
          className={css`
            color: ${theme.color.turquoise50} !important;
          `}
        >
          {msg}
        </Link>
      )}
    />
  )
}
